import {RoleEnum} from 'src/api/ProactApiClient';
import {useAppSelector} from 'src/redux/hooks';

export interface RoleGuardProps {
  roles: RoleEnum[];
  showDeniedMessage?: boolean;
  children?: React.ReactNode;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
  showDeniedMessage = false,
  roles,
  children,
}) => {
  const {session, isSuperAdmin} = useAppSelector(s => s.session);
  const role = session?.user?.roleId ?? RoleEnum.InstanceUser;

  if (isSuperAdmin || roles.includes(role) === true) {
    return <>{children}</>;
  }

  return (
    <>
      {showDeniedMessage === true &&
        'You do not have permission to access this feature.'}
    </>
  );
};
